module.exports = __webpack_public_path__ + "img/Progressive_Web_Applications_in_2021.94018ee0.jpeg";